import { Container, Row, Col } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { Title, Description } from "@/ui";

export default function FeaturedListImage({
  className,
  bgColor,
  title,
  titleColor,
  description,
  items = [],
  button,
  img,
  reverse,
  sectionId,
  statColor,
}) {
  if (!items.length) return null;

  const variantClass = button?.variant?.startsWith("btn-") ? button.variant : `btn-${button?.variant}`;

  return (
    <div id={sectionId} className={clsx(className, bgColor)}>
      <Container>
        <Title title={title} className={clsx("mb-3", titleColor)} />
        <Description description={description} />
        <Row
          className={clsx("flex-column-reverse gx-5 ", { "flex-md-row-reverse": reverse, "flex-md-row": !reverse })}
          style={{ alignItems: "center" }}
        >
          <Col md={5} className={classes.imageCol}>
            <div className={classes.imageContainer}>
              {img?.url && <img src={img.url} alt="Featured" className={classes.image} />}
            </div>
          </Col>
          <Col md={7}>
            <ol className={classes.list}>
              {items.map(({ title, text, titleStatColour, textStatColour }, idx) => (
                <li key={idx} className={classes.listItem}>
                  <div className="d-flex align-items-start gap-3">
                    {/* Make this container for number and title flex row aligned */}
                    <div className="d-flex align-items-start gap-2">
                      <Title
                        title={String(idx + 1).padStart(2, "0")}
                        tag="h3"
                        className={clsx("h3", classes.index, statColor)}
                      />

                      <div>
                        <Title title={title} tag="h3" className={clsx("h3", titleStatColour)} />
                        <Description description={text} className={clsx("description", textStatColour)} />
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ol>

            {button?.label && button?.href && (
              <a href={button.href} className={clsx("btn", classes.buttonSpacing, variantClass)}>
                {button.label}
              </a>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
